import type { CityConfig } from "@/pages/city-template/types";

export const buffaloConfig: CityConfig = {
  city: "Buffalo",
  state: "New York",
  stateAbbr: "NY",
  slug: "buffalo",
  route: "/cities/buffalo",
  title: "Emergency & Expedited Passport Buffalo, NY | Same Day Passport Services",
  metaDescription:
    "Emergency passport Buffalo NY — same day, 24-hour, and 3-5 day expedited passport processing. Fast Passport Center serves Buffalo, Amherst, Cheektowaga, and all of Erie County. Avoid the 8-11 week wait.",
  h1: "Emergency & Expedited Passport Services in Buffalo, NY",
  heroSubtitle:
    "Buffalo is the gateway to Western New York — and travelers here deserve passport service that moves at the same pace. Fast Passport Center delivers emergency passports as quick as 24 hours, with 3-5 day expedited service for Buffalo, Amherst, Cheektowaga, and all of Erie County.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Buffalo%20New%20York%20skyline%20at%20sunset%20with%20Lake%20Erie%20waterfront%2C%20historic%20grain%20elevators%20and%20modern%20buildings%20along%20the%20waterfront%2C%20warm%20golden%20light%20reflecting%20off%20water%2C%20dramatic%20sky%20with%20colorful%20clouds%2C%20modern%20travel%20photography%2C%20clean%20composition%2C%20no%20text%20overlay%2C%20high%20contrast%20urban%20waterfront%20landscape&width=1600&height=700&seq=ny-buffalo-hero-001&orientation=landscape",
  heroImageAlt: "Buffalo New York skyline at sunset with Lake Erie waterfront",
  geoPosition: "42.8864; -78.8784",
  geoPlacename: "Buffalo, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~375 miles from Buffalo",
  },
  nearbyCitiesZips: [
    { name: "Buffalo", zips: "14201-14204, 14206-14210, 14211-14214, 14215, 14216, 14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224, 14225, 14226, 14227, 14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263, 14264, 14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
    { name: "Amherst", zips: "14226, 14228, 14231" },
    { name: "Cheektowaga", zips: "14225, 14227, 14215" },
    { name: "Tonawanda", zips: "14150, 14217, 14223" },
    { name: "North Tonawanda", zips: "14120" },
    { name: "Niagara Falls", zips: "14301-14305, 14302" },
    { name: "Lewiston", zips: "14092" },
    { name: "Kenmore", zips: "14217, 14223" },
    { name: "West Seneca", zips: "14218, 14224, 14227" },
    { name: "Lackawanna", zips: "14218" },
    { name: "Hamburg", zips: "14075" },
    { name: "Orchard Park", zips: "14127" },
    { name: "Depew", zips: "14043" },
    { name: "Lancaster", zips: "14086" },
    { name: "Williamsville", zips: "14221, 14231" },
    { name: "Snyder", zips: "14226" },
    { name: "Eggertsville", zips: "14226" },
    { name: "Rochester", zips: "14602-14610, 14611, 14612, 14613, 14614, 14615, 14616, 14617, 14618, 14619, 14620, 14621, 14622, 14623, 14624, 14625, 14626, 14627, 14642, 14650, 14652, 14653, 14692" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "New York City", zips: "10001-10045, 10199, 10280, 10282" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Buffalo travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with reserved agency submission slots.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Serving All of Erie County",
      desc: "Buffalo, Amherst, Cheektowaga, Tonawanda, West Seneca, and every Western New York community.",
    },
  ],
  testimonials: [
    {
      name: "Mark R.",
      location: "Amherst, NY",
      rating: 5,
      text: "I needed an emergency passport from Buffalo for a last-minute business trip to Toronto. Fast Passport Center delivered in 5 days. The process was smooth and the agent kept me updated daily.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa H.",
      location: "Cheektowaga, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. They caught a form error that would have delayed everything.",
      service: "Passport Renewal",
    },
    {
      name: "Robert D.",
      location: "West Seneca, NY",
      rating: 5,
      text: "First-time passport for my son. The agent explained the two-parent rule and helped us get the consent forms right. Processed in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "buf-1",
      name: "Buffalo Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1200 William Street",
      city: "Buffalo",
      state: "NY",
      zip: "14240",
      phone: "716-846-2101",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Buffalo",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Buffalo passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "buf-2",
      name: "Amherst Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "5200 Main Street",
      city: "Amherst",
      state: "NY",
      zip: "14221",
      phone: "716-832-2275",
      hours: "Mon-Fri 8:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Amherst, NY",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Amherst and Williamsville residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "buf-3",
      name: "Cheektowaga Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1250 French Road",
      city: "Cheektowaga",
      state: "NY",
      zip: "14227",
      phone: "716-668-2374",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Cheektowaga, NY",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Nearby alternative for Cheektowaga and Depew residents.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Buffalo, NY?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Buffalo residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Buffalo?",
      a: "The Buffalo Main Post Office at 1200 William Street offers passport acceptance services. The Amherst Post Office at 5200 Main Street and Cheektowaga Post Office at 1250 French Road are also nearby alternatives. First-time applicants and those not eligible for mail-in renewal must apply in person at these facilities. Fast Passport Center guides you through the acceptance clerk process.",
    },
    {
      q: "Can I get same-day passport photos in Buffalo, NY?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations in Buffalo, Amherst, and Cheektowaga. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements before submission.",
    },
    {
      q: "How much does an expedited passport cost in Buffalo?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Buffalo passport needs.",
    },
    {
      q: "Do I need to drive to the New York Passport Agency from Buffalo?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency at 376 Hudson Street in Manhattan at all. As a registered courier, we handle the agency submission for you. The drive is nearly 400 miles, making it impractical for most Buffalo residents.",
    },
    {
      q: "What is the fastest way to renew a passport in Buffalo, New York?",
      a: "The fastest way to renew a passport in Buffalo is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Buffalo, NY?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Buffalo and all of Erie County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Buffalo, NY?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Buffalo. We serve Buffalo and all of Western New York through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Buffalo / Amherst", address: "various CVS locations in Buffalo, Amherst, and Cheektowaga", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Buffalo", address: "various Walgreens locations near Buffalo and Erie County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Buffalo", address: "various UPS Store locations in Buffalo and Amherst", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Buffalo", address: "various FedEx Office locations in Buffalo", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart — Buffalo / Amherst", address: "various Walmart locations near Buffalo", hours: "Mon-Sun 7:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Buffalo",
      address: "184 Sweeney Street, North Tonawanda, NY 14120",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Western New York DMV office. Accepts walk-ins but appointments are strongly recommended. REAL ID and driver's license services.",
      featured: true,
    },
    {
      name: "NYS DMV — Cheektowaga",
      address: "2320 Walden Avenue, Cheektowaga, NY 14225",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Cheektowaga DMV office for license renewals and REAL ID applications. Convenient for Buffalo and Erie County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "In Cheektowaga, NY",
      address: "4200 Genesee Street, Buffalo, NY 14225",
      note: "Western New York's primary airport with domestic flights and limited international connections to Canada. Just a short drive from downtown Buffalo.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Niagara Airport",
      featured: true,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "~75 miles from Buffalo",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Rochester's airport with domestic flights. Alternative option for Buffalo-area travelers.",
      flightUrl: "https://www.mccoyairport.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
    {
      code: "YYZ",
      name: "Toronto Pearson International Airport",
      distance: "~105 miles from Buffalo (in Canada)",
      address: "6301 Silver Dart Dr, Mississauga, ON L5P 1B2, Canada",
      note: "Canada's largest international airport. Many Buffalo residents use Toronto Pearson for international flights, especially to Europe and Asia.",
      flightUrl: "https://www.torontopearson.com/",
      flightLabel: "Toronto Pearson Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Buffalo travelers with urgent departures within 24 hours to 2 weeks. Reserved agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Buffalo residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Buffalo residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Buffalo residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Buffalo, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Buffalo residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Buffalo travelers with immediate departure needs." },
    { name: "Passport Renewal", description: "Fast passport renewal for Buffalo residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Buffalo residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Buffalo residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Buffalo." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Buffalo." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Buffalo travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Buffalo travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Buffalo-area team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application with reserved agency processing slots.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Buffalo address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Niagara Falls", route: "/cities/niagara-falls" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Buffalo and all of Western New York as a remote courier service. We do not have a physical office in Buffalo, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Buffalo, NY area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Buffalo and all surrounding Erie County communities. From Amherst to Cheektowaga, Tonawanda to West Seneca — we serve every Western New York community with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Buffalo and all surrounding Western New York communities. Whether you're in the city or the suburbs, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Buffalo customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Buffalo travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Buffalo and Erie County travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Buffalo, NY. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default buffaloConfig;